import React, { useState, useEffect } from 'react';
import ActorCard from './ActorCard';
import ActorInfoSection from './ActorInfoSection';
import RemoveButton from './RemoveButton';
import "../styles/RootCardSection.css";
import "../styles/ActorCard.css";

// Resize container width based on connected actors and screen size
const resizeContainerWidth = (connectedActors) => {
  const container = document.querySelector(".root-cards-container");
  if (container) {
    const isSmallScreen = window.innerWidth < 800;  // Check if the screen width is less than 800px
    const baseWidth = isSmallScreen ? 9 : 15;  // 9rem for small screens, 15rem for larger screens
    const extraWidth = connectedActors.length;  // Add 1rem per actor

    // Set the width based on the number of actors and screen size
    container.style.width = `${baseWidth + extraWidth}rem`;
  }
};

const RootCardSection = ({actorPair, connectedMovies, connectedActors, handleRemoveLastActor, completeConnection, onHoverChange}) => {
  const [hoveredActorName, setHoveredActorName] = useState(actorPair.actor_1.name);

  useEffect(() => {
    if (connectedActors.length > 0) {
      setHoveredActorName(connectedActors[connectedActors.length - 1].name);
      onHoverChange(Array.from(connectedMovies[connectedActors.length - 1]));
      handleCardHoverExit();
    } else {
      setHoveredActorName(actorPair.actor_1.name);
      onHoverChange(["Start your connection from this actor!"]);
      handleCardHoverExit();
    }

    // Initially adjust container width when connected actors change
    resizeContainerWidth(connectedActors);

  }, [connectedActors, actorPair, completeConnection]);

  // Add resize event listener to adjust the container width when the window is resized
  useEffect(() => {
    const handleResize = () => {
      resizeContainerWidth(connectedActors); // Recalculate the width on window resize
    };

    // Attach resize listener
    window.addEventListener('resize', handleResize);

    // Clean up the event listener when component is unmounted
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [connectedActors]); // Re-run when connectedActors change
  


  const handleCardHover = (e, index) => {
    e.currentTarget.style.zIndex = connectedActors.length + 1;
    if (index > 0) {
      setHoveredActorName(connectedActors[(index-1)].name);
      onHoverChange(Array.from(connectedMovies[index - 1]));
    }
    else {
      setHoveredActorName(actorPair.actor_1.name);
      onHoverChange(["Start your connection from this actor!"])
    }

    const siblings = Array.from(e.currentTarget.parentNode.children).slice(index+1);

    siblings.forEach((sibling, i) => {
      sibling.style.zIndex = connectedActors.length - (i+1);
    });

  }

  const handleCardHoverExit = () => {
    document.querySelectorAll('.actor-image-container').forEach((el, i) => {
      el.style.zIndex = i;
    })
    if (connectedActors.length > 0) {
      setHoveredActorName(connectedActors[(connectedActors.length - 1)].name);
      if (completeConnection) {
        onHoverChange(Array.from(connectedMovies[connectedMovies.length -1]));
      }
      else {
        onHoverChange(Array.from(connectedMovies[(connectedActors.length - 1)]));
      }
    }
    else {
      setHoveredActorName(actorPair.actor_1.name);
    }
  }

  return (
    <>
        <div className="root-cards-container">
           
            <div className="card-stack-wrapper">
              <div className="actor-image-container" onMouseEnter={(e) => handleCardHover(e,0)} onMouseLeave={handleCardHoverExit}>
                        <img src={actorPair.actor_1.image_url}/>
              </div>
              {connectedActors.length > 0 && (
                <>
                  {connectedActors.map((actor, index) => (
                    <div className="actor-image-container" onMouseEnter={(e) => handleCardHover(e,(index+1))} onMouseLeave={handleCardHoverExit}>
                      <img src={actor.image_url}/>
                      {(connectedActors.length > 0 && index == connectedActors.length - 1) && (
                        <RemoveButton handleRemoveLastActor={handleRemoveLastActor} completeConnection={completeConnection}/>
                      )}
                    </div>
                  ))}
                </>
              )}
            </div>
            <ActorInfoSection actorName = {hoveredActorName}/>
        </div>
    </>
  )
}

export default RootCardSection